export default __webpack_public_path__ + "assets/f5d5b467eaa8296688d9a16ec728bbb1.png";